import { ApiProductclass } from '@/models/api/productclass'

export default class ContactLensRoot {
  static create(root: ApiProductclass): ContactLensRoot {
    return new ContactLensRoot(root)
  }

  private constructor(private _root: ApiProductclass) {}

  get name(): string {
    return this._root.name
  }

  get brandId(): string {
    return this._root.brandId
  }

  get brandEnglishName(): string {
    return this._root.belongingBrand.englishName
  }

  get categoryPathnames(): string[] {
    return this._root.categories.map(c => c.pathname)
  }

  /**
   * 1箱あたりのレンズ枚数
   */
  get lensCountPerBox(): number {
    return this._root.get('aux_long_1', 0)
  }
}
